import React, { Component } from 'react'
import { object, string } from 'prop-types'
import { Link } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import { matchRoutes, renderRoutes } from 'react-router-config'

import TranslationContext from './utils/TranslationContext'
import { TranslationHelper } from './utils/translationHelpers'
import I18n from './utils/i18n'
import { fetchAction } from '../store/actions/fetchAction'

function createURL(url, locale, apiURL) {
	const newUrl = `${ __SERVER__ ? apiURL : '' }/api/${ url }`
	const hasQueryParams = newUrl.indexOf('?')
	if (!locale) {
		return newUrl
	} else if (hasQueryParams !== -1) {
		return `${ newUrl }&locale=${ locale }`
	}
	return `${ newUrl }?locale=${ locale }`
}

export const fetchData = (store, location, routes, fetchOptions) => {
	const { dispatch } = store
	const { authorization, apiUrl } = (fetchOptions || {})
	const branch = matchRoutes(routes, location)
	// const currentState = getState() , getState
	const promises = branch.reduce((sum, { route, match }) => {
		const { locale } = match.params
		const compnentFetch = (route.component.fetchQueries || []).map(ele => {
			// Maybe have Dataloader be root component
			// const currentQueryStatus = currentState.fetch.status[md5(ele)]
			// if (currentQueryStatus && currentQueryStatus.status === 'success' && Date.now() - currentQueryStatus.lastRead < 5 * 60 * 1000) {
			// 	return
			// }
			const options = {
				fetchUrl: ele,
				authorization,
				apiUrl
			}
			ele = createURL(ele, locale, apiUrl)
			for (const [key, value] of Object.entries(match.params)) {
				const regexString = new RegExp(`\\$${ key }`, 'gi')
				if (ele.match(regexString)) {
					ele = ele.replace(regexString, value)
				}
			}
			return dispatch(fetchAction(ele, ['FETCH_QUERIES_START', 'FETCH_QUERIES_SUCCESS', 'FETCH_QUERIES_REJECT'], options))
		})
		return [...sum, ...compnentFetch]
	}, [])
	return Promise.all(promises)
}


export class DataLoader extends Component {

	static propTypes = {
		match: object,
		location: object,
		cookie: string,
		route: object
	}

	static contextTypes = {
		store: object
	}

	// static getDerivedStateFromProps(nextProps, prevState) {

	// }
	constructor(props) {
		super(props)
		const { match: { params } } = props
		const locale = params.locale || 'pt'
		const i18n = I18n.use(locale)
		this.state = {
			i18n,
			locale,
			translationHelper: new TranslationHelper(i18n)
		}
	}

	// TODO: didMount() for clientSide
	componentDidMount() {
		const { store } = this.context
		const { location, route } = this.props
		fetchData(store, location.pathname, route.routes)
	}

	componentWillReceiveProps(nextProps) {
		const { match: { params }, route } = nextProps
		const locale = (params || {}).locale || 'pt'
		const navigated = nextProps.location !== this.props.location
		if (navigated) {
			const { store } = this.context
			fetchData(store, nextProps.location.pathname, route.routes)
		}
		this.setState(prevState => {
			const { locale: prevLocale } = prevState
			if (locale !== prevLocale) {
				const i18n = I18n.use(locale)
				return {
					i18n,
					locale,
					translationHelper: new TranslationHelper(i18n)
				}
			}
			return {}
		})
	}

	changeLocale(locale) {
		const { location: { pathname }, match: { params } } = this.props
		if ((!params.locale && locale === '') || params.locale === locale) {
			return null
		} else if (params.locale) {
			return `/${ locale }${ pathname.split('/').slice(2).join('/') }`
		} else {
			return `/${ locale }${ pathname }`
		}
	}
	createLocaleLink(to) {
		const { match: { params: { locale } } } = this.props
		return locale ? `/${ locale }${ to }` : to
	}

	renderLocales() {
		const { match: { params: { locale } } } = this.props
		const localeData = [
			{
				locale: '',
				name: 'Pt'
			},
			{
				locale: 'en',
				name: 'En'
			}
		]
		return localeData.map((ele, i) => {
			if (ele.locale !== locale && !(!locale && !ele.locale)) {
				return { name: ele.name, to: this.changeLocale(ele.locale) }
			}
			return false
		}).filter(r => r)
	}


	render() {
		const { store: { dispatch } } = this.context
		const { route } = this.props
		const { translationHelper, locale, i18n } = this.state
		const action = bindActionCreators(fetchAction, dispatch)
		return (
			<TranslationContext.Provider
				value={
					{
						locale,
						i18n,
						changeLocale: this.changeLocale.bind(this),
						createLocaleLink: this.createLocaleLink.bind(this),
						renderLocales: this.renderLocales.bind(this),
						translationHelper
						// translateMonth: translateMonth(i18n),
						// translateDay: translateDay(i18n)
					}
				}
			>
				{ renderRoutes(route.routes, { dispatch, fetchAction: action }) }
			</TranslationContext.Provider>
		)
	}
}



// WEBPACK FOOTER //
// ./src/client/DataLoader.js